const Backbone = require('backbone');
const _ = require('underscore');
const $ = require('jquery');
const appManager = require('../app-manager');
const SubtitleReader = require('../helpers/reader');
const AjaxComm = require('../helpers/ajax-communication');
const Keystrokes = require('../helpers/keystrokes-overwrite');
const languageContainer = require('../helpers/language-container');
const MovieModel = require('../scopes/movie');
const VideoPlayer = require('./player');
const SubtitleManager = require('./subtitle-manager');
const ControlMenu = require('./control-menu');
const template = require('../templates/main.jade');
const dispatcher = require('../dispatcher');
//const SubtitleInfo = require('./subtitle-info');

var MainView = Backbone.View.extend({
	autoRender: true,
	template: template(),
	model: new MovieModel(),
	subtitleManager: null,
	videoPlayer: null,
	controlMenu: null,
	initialize: async function (options) {
		_.extend(this, options);

		this.setElement(this.template);

		this.initEventListeners();

		if (this.autoRender) {
			this.render();
		}

		await this.fetchData();
		dispatcher.emit(dispatcher.events.APP_MODEL_INITIALIZED, this.model);
	},
	initEventListeners: function () {
		this.listenTo(dispatcher, dispatcher.events.BUILD_SETTINGS_CSS, this.buildSettingsCss);
		this.listenTo(dispatcher, dispatcher.events.RESET_SETTINGS_CSS, this.resetSettingsCss);
		this.listenTo(dispatcher, dispatcher.events.CHANGE_LANGUAGE, this.changeLanguage)
	},	
	render: function () {
		appManager.main.layout.append(this.$el);
		appManager.main.layout.find('.preloader').show();
		this.initSubtitleManager();
		this.initControlMenu();
		
		return this;
	},
	fetchData: function () {
		return SubtitleReader.readData(this.model).then(() => {
			appManager.main.layout.find('video').trigger('load');

			this.initVideoAPI();
			Keystrokes();
			AjaxComm();

			this.setLangEnv();
			this.subtitleManager.addSubtitlesEls();
			this.collectSettings();

			appManager.main.layout.find('.preloader').hide();
			appManager.main.layout.find('#app').show();
		});
	},
	changeLanguage: function () {
		appManager.main.layout.find('.preloader').show();
		dispatcher.emit(dispatcher.events.DISABLE_KEYBOARD_CONTROLS);
		dispatcher.emit(dispatcher.events.DISABLE_CONTROLS);
		dispatcher.emit(dispatcher.events.PAUSE_VIDEO);
		dispatcher.emit(dispatcher.events.DESTROY_ITEMS);

		SubtitleReader.readData(this.model).then(() => {
			dispatcher.emit(dispatcher.events.ENABLE_KEYBOARD_CONTROLS);
			dispatcher.emit(dispatcher.events.ENABLE_CONTROLS);

			this.setLangEnv();

			this.subtitleManager.undelegateEvents();
			this.subtitleManager.remove();

			this.initSubtitleManager();
			this.subtitleManager.addSubtitlesEls();

			appManager.main.layout.find('.preloader').hide();
		})
	},
	setLangEnv: function () {
		var available = this.model.get('availableLanguages');
		if (available.length > 0) {
			var currentId = this.model.get('currentLanguageId');

			var $subManager = this.$('.subtitle-manager');
			var $subVideo = this.$('.video-wrapper .subtitle-display');

			_.each(available, (obj) => {
				var className = obj.value.toLowerCase();

				$subManager.removeClass(className);
				$subVideo.removeClass(className);
			});

			var currentLang = _.findWhere(available, {
				key: currentId
			});

			// Safety check: if current language not found, use first available or skip
			if (!currentLang) {
				console.warn('Current language not found in availableLanguages. Using first available or skipping.');
				currentLang = available[0] || { value: 'default' };
			}

			languageContainer.set(currentLang);

			$subManager.addClass(currentLang.value.toLowerCase());
			$subVideo.addClass(currentLang.value.toLowerCase());
		}
	},
	initSubtitleManager: function () {
		this.subtitleManager = new SubtitleManager({
			collection: this.model.get('subtitle')
		});

		this.subtitleManager.$el.appendTo(this.$('.subtitle-manager'));
	},
	initSubtitleInfo: function () {
		this.subtitleInfo = new SubtitleInfo({
			model: this.model
		});

		this.subtitleInfo.$el.appendTo(this.$('.subtitle-manager'));
	},
	initVideoAPI: function () {
		this.videoPlayer = new VideoPlayer({
			model: this.model
		});

		this.videoPlayer.$el.appendTo(this.$('.video'));
	},
	initControlMenu: function () {
		this.controlMenu = new ControlMenu({
			model: this.model
		});

		this.controlMenu.$el.appendTo(this.$('.control-menu'));
	},
	collectSettings: function () {
		if (!localStorage.hasOwnProperty('capNsub-settings')) {
			this.defaultSettings();
		}
		this.buildSettingsCss();
	},
	defaultSettings: function () {
		var settings = {
			'player-ss': {
				//target: '#app .video .video-wrapper .subtitle-display table tr td input[type="text"]',
				target: '#app .video .video-wrapper .subtitle-display table tr td',
				property: 'font-size',
				value: '15'
			},
			'sub-list': {
				target: '#app .subtitle-manager .manager .subtitles .row .col',
				property: 'font-size',
				value: '12'
			},
			'sub-position-ss': {
				target: '#app .video .video-wrapper .subtitle-display',
				property: 'bottom',
				value: '6'
			},
			'shortcuts': 1,
			'player-fs': {
				target: '#app .video .video-wrapper.fullscreen .subtitle-display table tr td input[type="text"]',
				//target: '#app .video .video-wrapper .fullscreen .subtitle-display table tr td',
				property: 'font-size',
				value: '35'
			},
			'sub-position-fs': {
				target: '#app .video .video-wrapper.fullscreen .subtitle-display',
				property: 'bottom',
				value: '90'
			}
		};

		_.each(settings, function (obj, prop) {

			if (typeof obj === 'object' && !settings[prop].value) {
				settings[prop].value = this.$(obj.target).first().css(obj.property);
				settings[prop].value = settings[prop].value ? settings[prop].value.replace('px', '') : settings[prop].value;
			}
		});

		localStorage.setItem('capNsub-settings', JSON.stringify(settings));
	},
	buildSettingsCss: function () {
		var data = JSON.parse(localStorage.getItem('capNsub-settings'));

		var style = '<style id="settings-css">';

		_.each(data, function (obj) {
			if (typeof obj == 'object') {
				style += obj.target + '{' + obj.property + ':' + obj.value + 'px;' + '}';
			}
		});

		style += '</style>';

		$('body').find('#settings-css').remove;
		$('body').append(style);
	},
	resetSettingsCss: function () {
		localStorage.removeItem('capNsub-settings');
		this.defaultSettings();
		this.buildSettingsCss();
	}
});

module.exports = new MainView();


// WEBPACK FOOTER //
// ./app/views/main.js